import { z } from './routeBuilder';

export const orderDirectionType = z.union([z.literal('ASC'), z.literal('DESC')]);

export const orderBy = z.object({
  field: z.string(),
  direction: orderDirectionType,
});

export const resultActivatedFilter = z.object({
  filterBy: z.record(z.unknown()).optional(),
  searchBy: z.record(z.unknown()).optional(),
});

export const id = z.string();
export const offset = z.coerce.number();
export const limit = z.coerce.number();
export const none = z.undefined();
export const coerceBoolean = z
  .enum(['true', 'false'])
  .transform((value) => value === 'true')
  .or(z.boolean());

export function type<S>() {
  return z.custom<S>(() => true);
}
